import React from 'react';

interface TrustPilotIconProps {
  className?: string;
}

export const TrustPilotIcon = ({ className }: TrustPilotIconProps) => (
  <svg
    className={className}
    width="68"
    height="32"
    fill="none"
    viewBox="0 0 220.3 107"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {`
        .cls-1 {
          clip-path: url(#clip-path);
        }

        .cls-2 {
          fill: #191919;
        }

        .cls-3 {
          fill: #00b67a;
        }

        .cls-4 {
          fill: #005128;
        }

        .cls-5 {
          fill: #fff;
        }`}
      </style>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_3"
          data-name="Rectangle 3"
          width="220.3"
          height="54.1"
        />
      </clipPath>
    </defs>
    <g id="Group_3" data-name="Group 3" className="cls-1">
      <path
        id="Path_7"
        data-name="Path 7"
        className="cls-2"
        d="M57.9,19.2H80.2v4.2H71.4V46.8H66.6V23.3H57.9V19.2Zm21.3,7.6h4.1v3.9h.1a4.013,4.013,0,0,1,.8-1.6,6.2,6.2,0,0,1,1.4-1.4,5.244,5.244,0,0,1,1.8-1,4.477,4.477,0,0,1,2-.4h1.1c.2,0,.4.1.6.1v4.2a2.769,2.769,0,0,0-.9-.1c-.3,0-.6-.1-.9-.1a5.222,5.222,0,0,0-2.1.4,4.31,4.31,0,0,0-1.7,1.3,7.193,7.193,0,0,0-1.2,2.1,8.475,8.475,0,0,0-.4,2.9v9.5H79.5V26.8Zm31.9,19.9h-4.3V43.9h-.1a5.558,5.558,0,0,1-2.4,2.4,6.838,6.838,0,0,1-3.3.9c-2.6,0-4.5-.7-5.7-2s-1.8-3.3-1.8-5.9V26.8H98V39c0,1.8.3,3,1,3.7a3.763,3.763,0,0,0,2.8,1.1,5.269,5.269,0,0,0,2.3-.4,5.826,5.826,0,0,0,1.5-1.1,3.365,3.365,0,0,0,.8-1.7,7.8,7.8,0,0,0,.3-2.2V26.8h4.4V46.7Zm7.5-6.4a3.113,3.113,0,0,0,1.5,2.7,5.831,5.831,0,0,0,3,.8,7.084,7.084,0,0,0,1.4-.1,8.331,8.331,0,0,0,1.5-.4,2.258,2.258,0,0,0,1.1-.8,1.955,1.955,0,0,0,.4-1.4,1.816,1.816,0,0,0-.6-1.4,3.766,3.766,0,0,0-1.5-.9q-.9-.3-2.1-.6c-.8-.2-1.6-.3-2.4-.5a21.718,21.718,0,0,1-2.4-.7,9.332,9.332,0,0,1-2-1,3.907,3.907,0,0,1-1.4-1.7,4.869,4.869,0,0,1-.5-2.5,4.551,4.551,0,0,1,.8-2.7,6.969,6.969,0,0,1,2-1.8,7.822,7.822,0,0,1,2.7-.9,14.066,14.066,0,0,1,2.8-.3,15.263,15.263,0,0,1,3,.3,7.066,7.066,0,0,1,2.5,1.1,5.752,5.752,0,0,1,1.9,1.9,6.179,6.179,0,0,1,.9,2.8h-4.6a2.6,2.6,0,0,0-1.4-2.1,5.5,5.5,0,0,0-2.6-.5,4.484,4.484,0,0,0-1.1.1,5.274,5.274,0,0,0-1.2.3,1.456,1.456,0,0,0-.9.6,1.366,1.366,0,0,0-.4,1.1,1.612,1.612,0,0,0,.6,1.3,5.3,5.3,0,0,0,1.5.8q.9.3,2.1.6c.8.2,1.6.3,2.4.5a21.718,21.718,0,0,1,2.4.7,10.243,10.243,0,0,1,2.1,1,4.978,4.978,0,0,1,1.5,1.7,4.871,4.871,0,0,1,.6,2.5,5.571,5.571,0,0,1-.8,3,5.775,5.775,0,0,1-2.1,2,9.187,9.187,0,0,1-2.9,1.1,17.09,17.09,0,0,1-3.1.3,12.94,12.94,0,0,1-3.5-.4,8.038,8.038,0,0,1-2.8-1.3,6.736,6.736,0,0,1-1.9-2.2,7.448,7.448,0,0,1-.7-3.1h4.2Zm14.5-13.5h3.3v-6h4.4v6h4v3.3h-4V40.8a4.121,4.121,0,0,0,.1,1.2,1.136,1.136,0,0,0,.3.8,1.47,1.47,0,0,0,.6.5,3.73,3.73,0,0,0,1.2.2h.9c.3,0,.6-.1.9-.1v3.4c-.5.1-1,.1-1.4.2a6.6,6.6,0,0,1-1.4.1,10.364,10.364,0,0,1-2.8-.3,3.229,3.229,0,0,1-1.7-1,3.048,3.048,0,0,1-.8-1.6,13.785,13.785,0,0,1-.2-2.2V30.1h-3.3V26.8Zm14.8,0h4.2v2.7h.1a5.252,5.252,0,0,1,2.6-2.5,8.627,8.627,0,0,1,3.6-.8,10.33,10.33,0,0,1,4.1.8,8.23,8.23,0,0,1,2.9,2.3,8.393,8.393,0,0,1,1.7,3.4,14.027,14.027,0,0,1,.6,4.1,17.373,17.373,0,0,1-.5,3.9,8.477,8.477,0,0,1-1.6,3.3,7.542,7.542,0,0,1-2.7,2.3,7.9,7.9,0,0,1-3.8.9,12.252,12.252,0,0,1-1.9-.2,6.971,6.971,0,0,1-1.9-.6,7.218,7.218,0,0,1-2.9-2.4h-.1V54h-4.4V26.8Zm15.4,10a10.9,10.9,0,0,0-.3-2.6,9.432,9.432,0,0,0-1-2.3,5.175,5.175,0,0,0-1.7-1.6,4.751,4.751,0,0,0-2.4-.6,4.837,4.837,0,0,0-4.2,1.9,8.791,8.791,0,0,0-1.4,5.1,8.628,8.628,0,0,0,.4,2.8,5.078,5.078,0,0,0,1.1,2.2,6.549,6.549,0,0,0,1.8,1.5,4.709,4.709,0,0,0,2.4.5,4.626,4.626,0,0,0,2.5-.6,4.363,4.363,0,0,0,1.7-1.6,6.248,6.248,0,0,0,1-2.2c0-.8.1-1.7.1-2.5M171,19.2h4.4v4.2H171Zm0,7.6h4.4v20H171Zm8.4-7.6h4.4V46.8h-4.4Zm17.8,28.1a11.758,11.758,0,0,1-4.3-.8,10.155,10.155,0,0,1-3.2-2.2,9.131,9.131,0,0,1-2-3.3,11.582,11.582,0,0,1-.7-4.2,11.582,11.582,0,0,1,.7-4.2,9.206,9.206,0,0,1,5.2-5.5,11.368,11.368,0,0,1,4.3-.8,11.758,11.758,0,0,1,4.3.8,10.155,10.155,0,0,1,3.2,2.2,9.131,9.131,0,0,1,2,3.3,11.582,11.582,0,0,1,.7,4.2,11.226,11.226,0,0,1-.7,4.2,7.934,7.934,0,0,1-2,3.3,9.138,9.138,0,0,1-3.2,2.2,11.368,11.368,0,0,1-4.3.8m0-3.5a4.871,4.871,0,0,0,2.5-.6,6.9,6.9,0,0,0,1.8-1.6,5.973,5.973,0,0,0,1-2.3,10.9,10.9,0,0,0,.3-2.6,10.679,10.679,0,0,0-.3-2.5,9.432,9.432,0,0,0-1-2.3,5.48,5.48,0,0,0-1.8-1.6,5.135,5.135,0,0,0-2.5-.6,4.871,4.871,0,0,0-2.5.6,5.48,5.48,0,0,0-1.8,1.6,5.973,5.973,0,0,0-1,2.3,10.679,10.679,0,0,0-.3,2.5,11.529,11.529,0,0,0,.3,2.6,9.432,9.432,0,0,0,1,2.3,5.48,5.48,0,0,0,1.8,1.6,5.135,5.135,0,0,0,2.5.6m11.4-17h3.3v-6h4.4v6h4v3.3h-4V40.8a4.121,4.121,0,0,0,.1,1.2,1.136,1.136,0,0,0,.3.8,1.47,1.47,0,0,0,.6.5,3.73,3.73,0,0,0,1.2.2h.9c.3,0,.6-.1.9-.1v3.4c-.5.1-1,.1-1.4.2a6.6,6.6,0,0,1-1.4.1,10.364,10.364,0,0,1-2.8-.3,3.229,3.229,0,0,1-1.7-1,3.048,3.048,0,0,1-.8-1.6c-.1-.6-.2-1.4-.3-2.2V30.1h-3.3Z"
      />
    </g>
    <path
      id="Path_8"
      data-name="Path 8"
      className="cls-3"
      d="M26.4,0,20.2,19.2H0L16.3,31,10.1,50.2,26.4,38.3,42.7,50.2,36.5,31,52.8,19.2H32.6Z"
    />
    <path
      id="Path_9"
      data-name="Path 9"
      className="cls-4"
      d="M37.9,35.4,36.5,31,26.4,38.3Z"
    />
    <rect
      id="Rectangle_4"
      data-name="Rectangle 4"
      className="cls-3"
      width="41.1"
      height="40.4"
      transform="translate(1 66.6)"
    />
    <rect
      id="Rectangle_5"
      data-name="Rectangle 5"
      className="cls-3"
      width="41.1"
      height="40.4"
      transform="translate(45.5 66.6)"
    />
    <rect
      id="Rectangle_6"
      data-name="Rectangle 6"
      className="cls-3"
      width="41.1"
      height="40.4"
      transform="translate(90.1 66.6)"
    />
    <rect
      id="Rectangle_7"
      data-name="Rectangle 7"
      className="cls-3"
      width="41.1"
      height="40.4"
      transform="translate(134.6 66.6)"
    />
    <rect
      id="Rectangle_8"
      data-name="Rectangle 8"
      className="cls-3"
      width="41.1"
      height="40.4"
      transform="translate(179.2 66.6)"
    />
    <path
      id="Path_10"
      data-name="Path 10"
      className="cls-5"
      d="M21.5,94.3l6.3-1.6,2.6,8.1ZM35.9,84h-11L21.5,73.6,18.2,84H7.2l8.9,6.4-3.4,10.4,8.9-6.4,5.5-4Z"
    />
    <path
      id="Path_11"
      data-name="Path 11"
      className="cls-5"
      d="M66.1,94.3l6.3-1.6,2.6,8.1ZM80.5,84h-11L66.1,73.6,62.7,84h-11l8.9,6.4-3.4,10.4,8.9-6.4,5.5-4Z"
    />
    <path
      id="Path_12"
      data-name="Path 12"
      className="cls-5"
      d="M110.6,94.3l6.3-1.6,2.6,8.1ZM125,84H114l-3.4-10.4L107.2,84h-11l8.9,6.4-3.4,10.4,8.9-6.4,5.5-4Z"
    />
    <path
      id="Path_13"
      data-name="Path 13"
      className="cls-5"
      d="M155.2,94.3l6.3-1.6,2.6,8.1ZM169.6,84h-11l-3.4-10.4L151.8,84h-11l8.9,6.4-3.4,10.4,8.9-6.4,5.5-4Z"
    />
    <path
      id="Path_14"
      data-name="Path 14"
      className="cls-5"
      d="M199.7,94.3l6.3-1.6,2.6,8.1ZM214.1,84h-11l-3.4-10.4L196.3,84h-11l8.9,6.4-3.4,10.4,8.9-6.4,5.5-4Z"
    />
  </svg>
);
